<page-heading
  [title]="'crm.crm.pageTitle' | translate"
  [description]="'crm.crm.pageDescription' | translate"
/>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="formGroup">
            <div class="row g-2 justify-content-end">
              <div
                class="col-xs-12 col-lg-3 trend-datepicker justify-space-between"
              >
                <mat-date-range-input
                  [rangePicker]="picker"
                  formGroupName="dateRange"
                >
                  <input
                    matStartDate
                    [placeholder]="'crm.crm.startDate' | translate"
                    formControlName="dateStart"
                  />
                  <input
                    matEndDate
                    [placeholder]="'crm.crm.endDate' | translate"
                    formControlName="dateEnd"
                  />
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker" />
                <mat-date-range-picker #picker>
                  <mat-datepicker-actions>
                    <mat-select
                      class="input-field rounded-lg"
                      (selectionChange)="onPeriodChange($event)"
                      [placeholder]="'crm.crm.select' | translate"
                    >
                      <mat-option value="1">{{ 'crm.crm.today' | translate }}</mat-option>
                      <mat-option value="7">{{ 'crm.crm.last7Days' | translate }}</mat-option>
                      <mat-option value="15">{{ 'crm.crm.last15Days' | translate }}</mat-option>
                      <mat-option value="30">{{ 'crm.crm.last30Days' | translate }}</mat-option>
                      <mat-option value="60">{{ 'crm.crm.last60Days' | translate }}</mat-option>
                    </mat-select>
                    <button mat-raised-button matDatepickerApply class="btnOk">
                      OK
                    </button>
                  </mat-datepicker-actions>
                </mat-date-range-picker>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="d-flex flex-wrap gap-2">
      <div class="flex-fill">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="d-flex flex-column gap-2 position-relative">
                <h5 class="text-muted fw-normal mt-0 text-truncate">
                  {{ 'crm.crm.revenueBrl' | translate }}
                </h5>
                <p class="text-dark h2 mb-0">
                  {{ $safeNavigationMigration(kpis?.['totalRevenue']?.['$numberDecimal']) |  currency:'BRL':'symbol':'1.0-0' }}
                </p>

                <div class="position-absolute" style="top: 0; right: 0">
                  <i class="mdi mdi-currency-usd text-dark font-20"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="d-flex flex-column gap-2 position-relative">
                <h5 class="text-muted fw-normal mt-0 text-truncate">
                  {{ 'crm.crm.ordersCount' | translate }}
                </h5>
                <p class="text-dark h2 mb-0">
                  {{ kpis?.['totalOrders'] }}
                </p>

                <div class="position-absolute" style="top: 0; right: 0">
                  <i class="mdi mdi-cart text-dark font-20"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="d-flex flex-column gap-2 position-relative">
                <h5 class="text-muted fw-normal mt-0 text-truncate">
                  {{ 'crm.crm.averageTicketBrl' | translate }}
                </h5>
                <p class="text-dark h2 mb-0">
                  {{ $safeNavigationMigration(kpis?.['averageTicket']?.['$numberDecimal']) |  currency:'BRL':'symbol':'1.0-0' }}
                </p>

                <div class="position-absolute" style="top: 0; right: 0">
                  <i class="mdi mdi-currency-usd text-dark font-20"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="d-flex flex-column gap-2 position-relative">
                <h5 class="text-muted fw-normal mt-0 text-truncate">
                  {{ 'crm.crm.activeCustomers' | translate }}
                </h5>
                <p class="text-dark h2 mb-0">
                  {{ kpis?.['activeCustomers'] }}
                </p>

                <div class="position-absolute" style="top: 0; right: 0">
                  <i class="mdi mdi-account-group text-dark font-20"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-fill">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="d-flex flex-column gap-2 position-relative">
                <h5 class="text-muted fw-normal mt-0 text-truncate">
                  {{ 'crm.crm.newCustomers' | translate }}
                </h5>
                <p class="text-dark h2 mb-0">
                  {{ kpis?.['newCustomers'] }}
                </p>

                <div class="position-absolute" style="top: 0; right: 0">
                  <i class="mdi mdi-account-plus text-dark font-20"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="">{{ 'crm.crm.revenueBySellerTop5' | translate }}</h4>
          <!-- <div class="dropdown">
            <a
              href="#"
              class="dropdown-toggle arrow-none card-drop"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="mdi mdi-dots-vertical"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a href="javascript:void(0);" class="dropdown-item">Hoje</a>
              <a href="javascript:void(0);" class="dropdown-item">
                Últimos 7 dias
              </a>
              <a href="javascript:void(0);" class="dropdown-item">
                Últimos 30 dias
              </a>
            </div>
          </div> -->
        </div>

        <div class="card-body pt-0">
          <div class="mt-3" style="height: 320px">
            <ngx-charts-bar-vertical
              [scheme]="colorScheme"
              [results]="revenueBySeller"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [autoResize]="true"
            >
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h4 class="">{{ 'crm.crm.orders' | translate }}</h4>
          <!-- <div class="dropdown">
            <a
              href="#"
              class="dropdown-toggle arrow-none card-drop"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="mdi mdi-dots-vertical"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-end">
              <a href="javascript:void(0);" class="dropdown-item">Hoje</a>
              <a href="javascript:void(0);" class="dropdown-item">
                Últimos 7 dias
              </a>
              <a href="javascript:void(0);" class="dropdown-item">
                Últimos 30 dias
              </a>
            </div>
          </div> -->
        </div>
        <div class="card-body pt-0">
          <div class="mt-3" style="height: 320px">
            <ngx-charts-bar-vertical
              [scheme]="colorScheme"
              [results]="ordersChart"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [autoResize]="true"
            >
            </ngx-charts-bar-vertical>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <ul class="nav nav-tabs nav-bordered pt-3 gap-3" role="tablist">
          <li class="nav-item" role="presentation">
            <a
              class="nav-link active"
              id="top-clients-tab"
              data-bs-toggle="tab"
              data-bs-target="#top-clients"
              type="button"
              role="tab"
              aria-controls="top-clients"
              aria-selected="true"
            >
              <i
                class="mdi mdi-account-arrow-up top-clients-icon d-md-none d-block"
              ></i>
              <span class="d-none d-md-inline">{{ 'crm.crm.customers' | translate }}</span>
            </a>
          </li>
          <li class="nav-item" role="presentation">
            <a
              class="nav-link"
              id="orders-tab"
              data-bs-toggle="tab"
              data-bs-target="#orders"
              type="button"
              role="tab"
              aria-controls="orders"
              aria-selected="false"
            >
              <i class="mdi mdi-package-variant-closed d-md-none d-block"></i>
              <span class="d-none d-md-inline">{{ 'crm.crm.ordersTab' | translate }}</span>
            </a>
          </li>
        </ul>

        <div class="col-12 tab-content" id="topClientsOrdersContent">
          <div
            class="tab-pane fade show active custom-scroll-bar overflow-x-hidden py-3 px-1"
            id="top-clients"
            role="tabpanel"
            aria-labelledby="top-clients-tab"
          >
            <div class="table-responsive">
              <table class="table table-hover table-centered mb-0">
                <thead>
                  <tr>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableCustomer' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableRevenue' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableOrders' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableLastPurchase' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of pager.list; track $index) {
                  <tr>
                    <td>
                      <span class="font-15 fw-bold">
                        {{ item.customerName }}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{
                        $safeNavigationMigration(item.totalRevenue?.['$numberDecimal'])
                        | currency:'BRL':'symbol':'1.0-0'
                        }}
                      </span>
                    </td>
                    <td>
                      <span>{{ item.totalOrders }}</span>
                    </td>
                    <td>
                      <span>{{ item.lastPurchase }}</span>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              @if(pager.total > pager.perPage) {
              <paginator
                class="flex justify-content-center mt-3 mb-3"
                [pager]="pager"
                (onPager)="loadPage($event)"
              />
              }
            </div>
          </div>

          <div
            class="tab-pane fade custom-scroll-bar overflow-x-hidden py-3 px-1"
            id="orders"
            role="tabpanel"
            aria-labelledby="orders-tab"
          >
            <div class="table-responsive">
              <table class="table table-hover table-centered mb-0">
                <thead>
                  <tr>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableCode' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableDate' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableCustomer' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableSeller' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableStatus' | translate }}</th>
                    <th class="text-primary-emphasis">{{ 'crm.crm.tableTotalBrl' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for(item of orderPager.list; track $index) {
                  <tr>
                    <td>
                      <span class="font-15 fw-bold">{{ item.code }}</span>
                    </td>
                    <td>
                      <span>{{ item.date }}</span>
                    </td>
                    <td>
                      <span>-</span>
                    </td>
                    <td>
                      <span>{{ item.seller }}</span>
                    </td>
                    <td>
                      <span>
                        {{ item.status === true ? "Faturado" : "Pendente" }}
                      </span>
                    </td>
                    <td>
                      <span>{{ $safeNavigationMigration(item.total?.['$numberDecimal'])
                        | currency:'BRL':'symbol':'1.0-0' }}</span>
                    </td>
                  </tr>
                  }
                </tbody>
              </table>
              @if(orderPager.total > orderPager.perPage) {
              <paginator
                class="flex justify-content-center mt-3 mb-3"
                [pager]="orderPager"
                (onPager)="loadOrderPage($event)"
              />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Waiting for final definitions of KPIs and charts -->
  <!-- <div class="row">
    <div class="col-md-6 col-xl-3">
      <div class="card card-height">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="d-flex flex-column gap-2 text-muted">
              <h3 class="card-title text-truncate text-dark">
                Pipeline por Status
              </h3>
              <div>
                <span>Aberto</span>
                <span class="float-end">120 pedidos - R$ 380k</span>
              </div>
              <div>
                <span>Faturado</span>
                <span class="float-end">240 pedidos - R$ 820k</span>
              </div>
              <div>
                <span>Entrege/Fechado</span>
                <span class="float-end">360 pedidos - R$ 900k</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xl-3">
      <div class="card card-height">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="d-flex flex-column gap-2 text-muted">
              <h3 class="card-title text-truncate text-dark">
                Qualidade de Dados
              </h3>
              <div>
                <span>Pedidos sem vendedor</span>
                <span class="float-end">0,8%</span>
              </div>
              <div>
                <span>Pedidos sem cliente</span>
                <span class="float-end">1,5%</span>
              </div>
              <div>
                <span>Itens sem produto</span>
                <span class="float-end">2,0%</span>
              </div>
              <div>
                <span>Removidos</span>
                <span class="float-end">0,5%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xl-3">
      <div class="card card-height">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="d-flex flex-column gap-2 text-muted">
              <h3 class="card-title text-truncate text-dark">
                Mix de Produtos
              </h3>
              <div>
                <span
                  ><i class="mdi mdi-package-variant-closed"></i> SKU-01</span
                >
                <span class="float-end">24%</span>
              </div>
              <div>
                <span
                  ><i class="mdi mdi-package-variant-closed"></i> SKU-02</span
                >
                <span class="float-end">18%</span>
              </div>
              <div>
                <span
                  ><i class="mdi mdi-package-variant-closed"></i> SKU-03</span
                >
                <span class="float-end">12%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-xl-3">
      <div class="card card-height">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="d-flex flex-column gap-2" style="max-height: 95%">
              <h3 class="card-title text-truncate text-dark">Notas</h3>
              <div class="text-muted">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam
                minus molestias illum voluptates earum, ea consequuntur vel
                perspiciatis aut facere maiores repellat adipisci reprehenderit
                explicabo voluptas qui odio cumque esse!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>
